// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --nextpage-tab-active: #0b2d71;
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

.btn::after {
  content: none !important;
  display: none !important;
}

.details-page {
  background: var(--background-gray, var(--light));
  box-sizing: border-box;
  flex: 1 1 auto;
  margin: 0 auto !important;
  max-width: 1920px !important;
  min-height: 0;
  overflow: auto;
  padding: 0.65rem clamp(0.65rem, 2vw, 1.4rem) 0.75rem;
  width: 96% !important;
}

.details-actions {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.details-actions__commands {
  align-items: center;
  display: flex;
  gap: 0.6rem;
}

.back-action {
  align-items: center;
  background: #fff !important;
  border: 1px solid var(--primary) !important;
  color: var(--primary) !important;
  display: inline-flex;
  gap: 0.5rem;
  margin: 0 0 0.65rem;
  padding: 0.45rem 0.8rem;
}

.edit-action, .move-to-removed-action, .permanent-delete-action {
  align-items: center;
  display: inline-flex;
  gap: 0.5rem;
  margin: 0 0 0.65rem;
}

.edit-action mat-icon, .move-to-removed-action mat-icon, .permanent-delete-action mat-icon {
  font-size: 1.15rem;
  height: 1.15rem;
  line-height: 1.15rem;
  width: 1.15rem;
}

.back-action:hover,
.back-action:focus-visible {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
  color: #fff !important;
}

.back-action mat-icon {
  font-size: 1.15rem;
  height: 1.15rem;
  line-height: 1.15rem;
  width: 1.15rem;
}

.instrument-header {
  background: #fff;
  border: 1px solid #dee2e6;
  border-left: 4px solid var(--primary);
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 1.2rem !important;
  max-width: none !important;
  min-height: 58px !important;
  padding: 0.9rem clamp(1rem, 3vw, 2rem);
  position: relative;
  text-align: center;
  width: auto !important;
}

.instrument-header::before,
.instrument-header::after {
  content: none !important;
  display: none !important;
}

.instrument-header__title {
  flex: 1 1 auto;
}

.instrument-header p, .instrument-header h1 {
  margin: 0;
}

.instrument-header .eyebrow {
  color: var(--primary);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 0.15rem;
  text-transform: uppercase;
}

.instrument-header h1 {
  color: var(--dark);
  font-size: clamp(1.3rem, 2vw, 1.65rem);
  font-weight: 700;
  line-height: 1.15;
}

.instrument-header .page-introduction {
  color: var(--secondary);
  font-size: 0.82rem;
  margin-top: 0.25rem;
}

.removed-badge {
  background: var(--secondary);
  border: 1px solid var(--secondary);
  border-radius: 999px;
  color: #fff;
  flex: 0 0 auto;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 0.35rem 0.7rem;
  position: absolute;
  right: clamp(1rem, 3vw, 2rem);
}

.tab-content {
  padding: 24px 4px;
}

.overview-sections {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.overview-section {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  min-width: 0;
  padding: 18px;
}

.overview-section--wide {
  grid-column: 1/-1;
}

.overview-section__heading {
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  color: var(--primary);
  display: flex;
  gap: 9px;
  margin-bottom: 14px;
  padding-bottom: 11px;
}

.overview-section__heading mat-icon {
  flex: 0 0 auto;
}

.overview-section__heading h2 {
  color: var(--dark);
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
}

.overview-fields {
  display: grid;
  gap: 14px 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0;
}

.overview-fields > div {
  min-width: 0;
}

.overview-fields dt {
  color: var(--secondary);
  font-size: 0.7rem;
  font-weight: 700;
  margin: 0 0 4px;
  text-transform: uppercase;
}

.overview-fields dd {
  color: var(--dark);
  font-size: 0.88rem;
  font-weight: 600;
  margin: 0;
  overflow-wrap: anywhere;
}

.overview-fields--compact {
  gap: 11px 14px;
}

.overview-schedule-list {
  display: flex;
  flex-direction: column;
}

.overview-schedule {
  border-top: 1px solid #e9ecef;
  margin-top: 14px;
  padding-top: 12px;
}

.overview-schedule__heading {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
  margin-bottom: 10px;
}

.overview-schedule__heading strong {
  color: var(--dark);
  font-size: 0.9rem;
}

.overview-inactive, .overview-manual {
  background: #f1f3f5;
  border-radius: 3px;
  color: #5c6770;
  display: inline-block;
  font-size: 0.68rem;
  font-weight: 700;
  margin-left: 5px;
  padding: 2px 6px;
}

.overview-empty {
  color: var(--secondary);
  font-size: 0.84rem;
  margin: 12px 0 0;
}

.lifecycle-events {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.lifecycle-event {
  background: #f8f9fa;
  border-left: 3px solid var(--primary);
  padding: 11px 13px;
}

.lifecycle-event strong, .lifecycle-event span {
  display: block;
}

.lifecycle-event span {
  color: var(--secondary);
  font-size: 0.8rem;
  margin-top: 3px;
}

.lifecycle-event p {
  margin: 7px 0 0;
  overflow-wrap: anywhere;
}

.two-column {
  display: grid;
  grid-template-columns: minmax(280px, 0.8fr) minmax(400px, 1.4fr);
  gap: 20px;
}

.panel {
  min-width: 0;
  padding: 20px;
  border: 1px solid #dee2e6;
  background: white;
}

.panel h2, .section-heading h2 {
  margin: 0 0 18px;
  font-size: 1.15rem;
}

.inline-form {
  display: flex;
  align-items: center;
  gap: 10px;
}

.inline-form mat-form-field {
  flex: 1;
}

.assignment-form {
  align-items: flex-start;
}

.assignment-form .action-button {
  height: 56px;
  margin-top: 4px;
}

::ng-deep .calibration-item-select-panel .mat-mdc-optgroup-label {
  background: #f1f3f5;
  color: #495057;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  min-height: 34px;
  text-transform: uppercase;
}

::ng-deep .calibration-item-select-panel .calibration-item-option {
  border-bottom: 1px solid #e9ecef;
  min-height: 48px;
}

::ng-deep .calibration-item-select-panel .calibration-item-option:last-child {
  border-bottom: 0;
}

.calibration-item-option__name {
  display: block;
  line-height: 1.25;
  white-space: normal;
}

.action-button {
  border-radius: 0.25rem;
  font-weight: 600;
  min-height: 38px;
  padding: 0.45rem 1rem;
}

.action-button--primary, .action-button--primary:focus {
  background: var(--primary);
  border: 1px solid var(--primary);
  color: #fff;
}

.action-button--primary:hover {
  background: color-mix(in srgb, var(--primary) 86%, #000);
  border-color: color-mix(in srgb, var(--primary) 86%, #000);
  color: #fff;
}

.action-button--outline, .action-button--outline:focus {
  background: #fff;
  border: 1px solid var(--primary);
  color: var(--primary);
}

.action-button--outline:hover {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}

.action-button:disabled {
  background: #e9ecef;
  border-color: #ced4da;
  color: #6c757d;
  cursor: not-allowed;
  opacity: 1;
}

.assignment-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
}

.assignment-content {
  align-items: center;
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(0, 1fr) auto;
  width: 100%;
}

.assignment-actions {
  align-items: center;
  display: inline-flex;
  gap: 8px;
}

.activation-due-date {
  color: var(--secondary);
  display: grid;
  font-size: 0.68rem;
  font-weight: 700;
  gap: 2px;
  text-transform: uppercase;
}

.activation-due-date input {
  border: 1px solid #adb5bd;
  border-radius: 4px;
  color: var(--dark);
  font: inherit;
  padding: 5px 7px;
  text-transform: none;
}

.assignment-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.assignment-title {
  color: var(--dark);
  font-size: 0.92rem;
  font-weight: 700;
}

.assignment-meta {
  align-items: center;
  display: flex !important;
  gap: 10px;
  margin-top: 5px;
}

.frequency-badge {
  background: color-mix(in srgb, var(--primary) 9%, white);
  border: 1px solid color-mix(in srgb, var(--primary) 25%, white);
  border-radius: 999px;
  color: var(--primary);
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 8px;
}

.assignment-status {
  align-items: center;
  color: #276749;
  display: inline-flex;
  font-size: 0.75rem;
  gap: 5px;
}

.assignment-status__dot {
  background: #2f855a;
  border-radius: 50%;
  height: 7px;
  width: 7px;
}

.assignment-status--inactive {
  color: var(--secondary);
}

.assignment-status--inactive .assignment-status__dot {
  background: var(--secondary);
}

.assignment-item--inactive {
  opacity: 0.72;
}

.due-override {
  border-top: 1px solid #dee2e6;
  margin-top: 16px;
  padding-top: 16px;
}

.due-override__dates {
  color: var(--secondary);
  display: flex;
  flex-wrap: wrap;
  font-size: 0.82rem;
  gap: 8px 20px;
}

.due-override__dates strong {
  color: var(--dark);
  margin-left: 5px;
}

.due-override__form {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.due-override__form mat-form-field {
  flex: 1 1 155px;
}

.due-override__form .action-button {
  margin-bottom: 20px;
}

.assignment-toggle {
  align-items: center;
  align-self: center;
  background: #f1f3f5;
  border: 1px solid #adb5bd;
  border-radius: 50%;
  color: #6c757d;
  cursor: pointer;
  display: inline-flex;
  height: 38px;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 38px;
}

.assignment-toggle mat-icon {
  font-size: 1.5rem;
  height: 1.5rem;
  line-height: 1.5rem;
  width: 1.5rem;
}

.assignment-toggle--active {
  background: #edf7f1;
  border-color: #8bc6a4;
  color: #276749;
}

.assignment-toggle:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.assignment-toggle:not(:disabled):hover {
  background: #e2e6ea;
  border-color: #6c757d;
  color: #495057;
}

.assignment-toggle--active:hover {
  background: #dff2e7;
  border-color: #2f855a;
  color: #1f5c3d;
}

.assignment-toggle:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.assignment-delete {
  align-items: center;
  background: #fff;
  border: 1px solid #e3a5ab;
  border-radius: 50%;
  color: #c82333;
  cursor: pointer;
  display: inline-flex;
  height: 38px;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 38px;
}

.assignment-delete mat-icon {
  font-size: 1.3rem;
  height: 1.3rem;
  line-height: 1.3rem;
  width: 1.3rem;
}

.assignment-delete:hover {
  background: #fbe9eb;
  border-color: #c82333;
}

.assignment-delete:focus-visible {
  outline: 2px solid #c82333;
  outline-offset: 2px;
}

.nextpage-panel-action {
  align-self: flex-start;
}

.period-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.period-grid .wide {
  grid-column: 1/-1;
}

.record-type-control {
  align-self: start;
  grid-column: 1/-1;
  justify-self: start;
  margin-bottom: 4px;
}

.calibration-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 6px 0 14px;
}

.calibration-field-group {
  min-width: 0;
}

.calibration-field-group--new-row {
  grid-column-start: 1;
}

.calibration-field-group--pair {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.calibration-field {
  padding: 14px;
  border: 1px solid #dee2e6;
}

.calibration-field mat-form-field {
  width: 100%;
}

.field-heading {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.field-heading span {
  color: var(--primary);
  font-size: 0.75rem;
  font-weight: 700;
}

.calibration-field p {
  min-height: 34px;
  margin: 5px 0 10px;
  color: var(--secondary);
  font-size: 0.8rem;
}

.numeric-value-field {
  transition: background-color 0.15s ease;
}

.numeric-value-field--target {
  --mdc-outlined-text-field-focus-outline-color: #2f855a;
  --mdc-outlined-text-field-hover-outline-color: #2f855a;
  --mdc-outlined-text-field-outline-color: #68a980;
}

.numeric-value-field--range {
  --mdc-outlined-text-field-focus-outline-color: #2879a8;
  --mdc-outlined-text-field-hover-outline-color: #2879a8;
  --mdc-outlined-text-field-outline-color: #6ca6c7;
}

.numeric-value-field--outside {
  --mdc-outlined-text-field-focus-outline-color: #b42318;
  --mdc-outlined-text-field-hover-outline-color: #b42318;
  --mdc-outlined-text-field-outline-color: #d66b63;
}

:host ::ng-deep .numeric-value-field--target .mat-mdc-text-field-wrapper {
  background: #edf8f1;
}

:host ::ng-deep .numeric-value-field--range .mat-mdc-text-field-wrapper {
  background: #eef6fb;
}

:host ::ng-deep .numeric-value-field--outside .mat-mdc-text-field-wrapper {
  background: #fff1f0;
}

mat-radio-group {
  display: flex;
  gap: 20px;
  padding: 12px 0;
}

.history-section {
  border-top: 1px solid #dee2e6;
}

.section-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.history-filters {
  display: flex;
  gap: 10px;
}

.history-filters mat-form-field {
  width: 120px;
}

.calibration-history-list {
  display: grid;
  gap: 10px;
}

.calibration-history-item {
  border: 1px solid #d7dce1;
  border-left: 4px solid color-mix(in srgb, var(--primary) 55%, white);
  border-radius: 6px !important;
  box-shadow: 0 1px 2px rgba(33, 37, 41, 0.08) !important;
  overflow: hidden;
}

.calibration-history-item.mat-expanded {
  border-left-color: var(--primary);
  box-shadow: 0 3px 10px rgba(33, 37, 41, 0.11) !important;
}

.calibration-history-item__icon {
  align-items: center;
  background: color-mix(in srgb, var(--primary) 9%, white);
  border-radius: 50%;
  color: var(--primary);
  display: inline-flex;
  flex: 0 0 36px;
  height: 36px;
  justify-content: center;
}

.calibration-history-item__icon mat-icon {
  font-size: 1.2rem;
  height: 1.2rem;
  line-height: 1.2rem;
  width: 1.2rem;
}

.calibration-history-item__summary {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.calibration-history-item__summary > strong {
  color: var(--dark);
  font-size: 0.9rem;
}

.calibration-history-item__period {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.calibration-history-item__period > span {
  background: #f1f3f5;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  color: #495057;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 7px;
}

.calibration-history-item__period > .frequency-badge {
  background: color-mix(in srgb, var(--primary) 9%, white);
  border-color: color-mix(in srgb, var(--primary) 25%, white);
  border-radius: 999px;
  color: var(--primary);
}

.calibration-history-item__date {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: right;
}

.calibration-history-item__date small {
  color: var(--secondary);
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
}

.calibration-history-item__date strong {
  color: #495057;
  font-size: 0.82rem;
  white-space: nowrap;
}

.calibration-status-counts {
  display: flex;
  gap: 5px;
}

.calibration-status-count {
  align-items: center;
  border: 1px solid #ced4da;
  border-radius: 3px;
  display: grid;
  grid-template-columns: auto auto;
  gap: 5px;
  padding: 3px 6px;
  white-space: nowrap;
}

.calibration-status-count small {
  color: #59636d;
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
}

.calibration-status-count strong {
  font-size: 0.75rem;
}

.calibration-status-count--target {
  background: #edf8f1;
  border-color: #a9d8b8;
  color: #276749;
}

.calibration-status-count--range {
  background: #eef6fb;
  border-color: #acd0e5;
  color: #245b78;
}

.calibration-status-count--outside {
  background: #fff1f0;
  border-color: #e5b4b0;
  color: #a52a2a;
}

.record-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.edit-calibration-action {
  align-items: center;
  display: inline-flex;
  gap: 6px;
}

.edit-calibration-action mat-icon {
  font-size: 1rem;
  height: 1rem;
  width: 1rem;
}

.record-values {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.record-value {
  background: #fff;
  border: 1px solid #dee2e6;
  display: grid;
  gap: 12px;
  padding: 14px;
}

.record-value.out-of-spec {
  border-left: 4px solid var(--danger);
  background: color-mix(in srgb, var(--danger) 5%, white);
}

.record-value__heading {
  align-items: flex-start;
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.record-value__heading > span {
  color: var(--secondary);
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
}

.value-comparison {
  align-items: stretch;
  display: grid;
  gap: 1px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  background: #dee2e6;
}

.value-comparison > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.value-comparison > div {
  background: #fff;
  padding: 8px 10px;
}

.value-comparison span {
  color: var(--secondary);
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
}

.value-comparison strong {
  overflow-wrap: anywhere;
}

.spec-status {
  align-items: center;
  color: #276749;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: 700;
  gap: 5px;
  justify-self: start;
}

.spec-status mat-icon {
  font-size: 1rem;
  height: 1rem;
  width: 1rem;
}

.spec-status--failed {
  color: var(--danger);
}

.record-note {
  align-items: flex-start;
  background: #fffaf0;
  border: 1px solid #e5d4a6;
  border-radius: 4px;
  display: grid;
  gap: 11px;
  grid-template-columns: 30px minmax(0, 1fr);
  margin-top: 16px;
  padding: 12px 14px;
}

.record-note__icon {
  align-items: center;
  background: #f5e9c8;
  border-radius: 50%;
  color: #725600;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  width: 30px;
}

.record-note__icon mat-icon {
  font-size: 1rem;
  height: 1rem;
  line-height: 1rem;
  width: 1rem;
}

.record-note strong {
  color: #4f410f;
  font-size: 0.8rem;
}

.record-note p {
  color: #3f3a2b;
  margin: 5px 0 0;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.date-changes {
  border-top: 1px solid #dee2e6;
  color: var(--secondary);
  font-size: 0.8rem;
  margin-top: 16px;
  padding-top: 12px;
}

.date-changes > strong {
  color: var(--dark);
}

.date-changes p {
  margin: 8px 0 0;
  overflow-wrap: anywhere;
}

.addenda-section {
  border-top: 1px solid #e1e5e9;
  margin-top: 20px;
  padding-top: 16px;
}

.addendum {
  align-items: flex-start;
  background: #f8f9fa;
  border: 1px solid #dfe3e7;
  border-left: 3px solid var(--primary);
  border-radius: 4px;
  display: grid;
  gap: 12px;
  grid-template-columns: 32px minmax(0, 1fr);
  padding: 13px 14px;
}

.addendum + .addendum {
  margin-top: 10px;
}

.addendum__icon {
  align-items: center;
  background: color-mix(in srgb, var(--primary) 10%, white);
  border-radius: 50%;
  color: var(--primary);
  display: inline-flex;
  height: 32px;
  justify-content: center;
  width: 32px;
}

.addendum__icon mat-icon {
  font-size: 1rem;
  height: 1rem;
  line-height: 1rem;
  width: 1rem;
}

.addendum__content {
  min-width: 0;
}

.addendum__heading {
  align-items: flex-start;
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.addendum__heading > strong {
  color: var(--dark);
  font-size: 0.86rem;
}

.addendum__metadata {
  align-items: center;
  color: var(--secondary);
  display: flex;
  flex-wrap: wrap;
  font-size: 0.72rem;
  gap: 4px 10px;
  justify-content: flex-end;
}

.addendum__metadata span {
  align-items: center;
  display: inline-flex;
  gap: 4px;
  white-space: nowrap;
}

.addendum__metadata span + span {
  border-left: 1px solid #ced4da;
  padding-left: 10px;
}

.addendum__metadata mat-icon {
  font-size: 0.85rem;
  height: 0.85rem;
  line-height: 0.85rem;
  width: 0.85rem;
}

.addendum p {
  color: #343a40;
  margin: 9px 0 0;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.addendum-form {
  align-items: stretch;
  margin-top: 14px;
}

.addendum-form mat-form-field {
  margin: 0;
}

.addendum-form .action-button {
  height: 56px;
  min-height: 56px;
}

.maintenance-form, .upload-form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.upload-form {
  gap: 1rem;
}

.upload-form h2 {
  margin: 0;
}

.upload-form mat-form-field {
  margin: 0;
}

.upload-form mat-form-field + mat-form-field {
  margin-top: -0.375rem;
}

.document-file-input {
  height: 1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
}

.document-drop-zone {
  align-items: center;
  background: var(--light);
  border: 2px dashed #9aa8b6;
  border-radius: 0.25rem;
  box-sizing: border-box;
  color: var(--dark);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  justify-content: center;
  min-height: 170px;
  padding: 1.25rem;
  text-align: center;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.document-drop-zone > mat-icon {
  color: var(--primary);
  font-size: 2rem;
  height: 2rem;
  width: 2rem;
}

.document-drop-zone > span {
  color: var(--secondary);
  font-size: 0.8rem;
}

.document-drop-zone:hover,
.document-drop-zone--active {
  background: color-mix(in srgb, var(--primary) 7%, white);
  border-color: var(--primary);
}

.document-drop-zone--selected {
  border-style: solid;
}

.document-drop-zone--disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.document-drop-zone__action {
  background: #fff;
  border: 1px solid var(--primary);
  border-radius: 0.25rem;
  color: var(--primary) !important;
  font-size: 0.875rem !important;
  font-weight: 600;
  margin-top: 0.35rem;
  padding: 0.4rem 0.75rem;
}

.document-file-input:focus + .document-drop-zone {
  border-color: var(--primary);
  outline: 2px solid color-mix(in srgb, var(--primary) 35%, transparent);
  outline-offset: 2px;
}

.upload-actions {
  align-items: flex-end;
  align-self: flex-end;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  text-align: right;
}

.history-list article {
  padding: 14px 0;
  border-bottom: 1px solid #dee2e6;
}

.history-list article > div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.history-list article span, .attachment-list article span, .upload-form small {
  color: var(--secondary);
  font-size: 0.8rem;
}

.history-list article p {
  margin: 8px 0;
  white-space: pre-wrap;
}

.attachment-list__header {
  border-bottom: 1px solid #adb5bd;
  color: var(--secondary);
  display: grid;
  font-size: 0.72rem;
  font-weight: 700;
  gap: 16px;
  grid-template-columns: minmax(0, 1.4fr) minmax(140px, 0.8fr) 84px;
  padding: 0 0 8px;
  text-transform: uppercase;
}

.attachment-list__header span:last-child {
  text-align: right;
}

.attachment-list article {
  align-items: center;
  border-bottom: 1px solid #dee2e6;
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(0, 1.4fr) minmax(140px, 0.8fr) 84px;
  padding: 12px 0;
}

.attachment-document {
  align-items: center;
  display: flex;
  gap: 12px;
  min-width: 0;
}

.attachment-document > div, .attachment-maintenance {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.attachment-maintenance span {
  overflow-wrap: anywhere;
}

.attachment-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.attachment-list strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.document-icon {
  color: var(--primary);
}

.icon-action {
  align-items: center;
  border-radius: 0.25rem;
  display: inline-flex;
  justify-content: center;
  min-height: 34px;
  min-width: 34px;
  padding: 0.25rem;
}

.icon-action mat-icon {
  font-size: 1.25rem;
  height: 1.25rem;
  line-height: 1.25rem;
  width: 1.25rem;
}

.icon-action--primary, .icon-action--primary:hover, .icon-action--primary:focus {
  color: var(--primary);
}

.icon-action--download {
  background: #fff;
  border: 1px solid var(--primary);
  color: var(--primary);
  cursor: pointer;
}

.icon-action--download:hover,
.icon-action--download:focus-visible {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}

.icon-action--download:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--primary) 35%, transparent);
  outline-offset: 2px;
}

.icon-action--danger {
  background: #fff;
  border: 1px solid var(--danger);
  color: var(--danger);
}

.icon-action--danger:hover,
.icon-action--danger:focus-visible {
  background: var(--danger);
  border-color: var(--danger);
  color: #fff;
}

.error-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0;
  padding: 10px 14px;
  border-left: 4px solid var(--danger);
  background: color-mix(in srgb, var(--danger) 10%, white);
  color: var(--danger);
}

.error-banner span {
  flex: 1;
}

.loading-state {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.empty-copy {
  color: var(--secondary);
}

:host ::ng-deep .mat-mdc-tab-header {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}

:host ::ng-deep .mat-mdc-tab .mdc-tab__text-label {
  color: var(--secondary);
}

:host ::ng-deep .mat-mdc-tab:hover {
  background: color-mix(in srgb, var(--nextpage-tab-active) 5%, white);
}

:host ::ng-deep .mat-mdc-tab.mdc-tab--active {
  background: color-mix(in srgb, var(--nextpage-tab-active) 9%, white);
}

:host ::ng-deep .mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: var(--nextpage-tab-active);
  font-weight: 700;
}

:host ::ng-deep .mat-mdc-tab-indicator__content--underline {
  border-color: var(--nextpage-tab-active) !important;
}

:host ::ng-deep .mat-mdc-form-field {
  --mdc-outlined-text-field-focus-label-text-color: var(--primary);
  --mdc-outlined-text-field-focus-outline-color: var(--primary);
  --mat-select-focused-arrow-color: var(--primary);
}

:host ::ng-deep .mat-mdc-radio-button {
  --mdc-radio-selected-focus-icon-color: var(--primary);
  --mdc-radio-selected-hover-icon-color: var(--primary);
  --mdc-radio-selected-icon-color: var(--primary);
  --mdc-radio-selected-pressed-icon-color: var(--primary);
}

:host ::ng-deep .mat-mdc-list-option.mdc-list-item--selected {
  background: color-mix(in srgb, var(--primary) 8%, white);
}

:host ::ng-deep .assignment-list .mat-mdc-list-option {
  --mat-radio-selected-icon-color: var(--primary);
  border: 1px solid #dee2e6;
  border-left: 3px solid transparent;
  min-height: 76px;
}

:host ::ng-deep .assignment-list .mdc-list-item__content,
:host ::ng-deep .assignment-list .mat-mdc-list-item-unscoped-content {
  width: 100%;
}

:host ::ng-deep .assignment-list .mat-mdc-list-option:hover {
  background: #f8f9fa;
}

:host ::ng-deep .assignment-list .mat-mdc-list-option.mdc-list-item--selected {
  border-left-color: var(--primary);
}

:host ::ng-deep mat-progress-bar {
  --mdc-linear-progress-active-indicator-color: var(--primary);
}

:host ::ng-deep .calibration-history-item .mat-expansion-panel-header {
  min-height: 68px;
  padding: 0 18px;
}

:host ::ng-deep .calibration-history-item .mat-expansion-panel-header:hover {
  background: #f8f9fa !important;
}

:host ::ng-deep .calibration-history-item .mat-expansion-panel-header-title {
  align-items: center;
  gap: 12px;
}

:host ::ng-deep .calibration-history-item .mat-expansion-panel-header-description {
  align-items: center;
  flex-grow: 0;
  gap: 14px;
  justify-content: flex-end;
  margin-right: 18px;
  min-width: 430px;
}

:host ::ng-deep .calibration-history-item .mat-expansion-panel-body {
  border-top: 1px solid #e9ecef;
  padding: 18px;
}

.blade-log {
  display: grid;
  gap: 1rem;
}

.blade-installation-form {
  align-items: center;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(3, minmax(150px, 1fr)) auto;
}

.blade-installation-form mat-form-field {
  width: 100%;
}

.table-responsive {
  overflow-x: auto;
}

.blade-log-table {
  border-collapse: collapse;
  min-width: 940px;
  width: 100%;
}

.blade-log-table th, .blade-log-table td {
  border-bottom: 1px solid #d9e1e8;
  padding: 0.7rem 0.6rem;
  text-align: left;
  vertical-align: middle;
}

.blade-log-table th {
  color: #455a64;
  font-size: 0.78rem;
  text-transform: uppercase;
}

.blade-log-table__out-of-spec {
  background: #fff2f2;
}

.blade-log-input {
  border: 1px solid #aebbc5;
  border-radius: 4px;
  max-width: 145px;
  padding: 0.45rem;
  width: 100%;
}

.blade-status {
  background: #e7f4eb;
  border-radius: 999px;
  color: #236437;
  display: inline-block;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.3rem 0.55rem;
  white-space: nowrap;
}

.blade-status--failed {
  background: #fde5e5;
  color: #a11f1f;
}

.blade-complete-action {
  white-space: nowrap;
}

@media (max-width: 900px) {
  .overview-sections {
    grid-template-columns: 1fr;
  }
  .overview-section--wide {
    grid-column: auto;
  }
  .two-column {
    grid-template-columns: 1fr;
  }
  .calibration-fields, .calibration-field-group--pair {
    grid-template-columns: 1fr;
  }
  .record-values {
    grid-template-columns: 1fr;
  }
  .calibration-status-count small {
    display: none;
  }
  :host ::ng-deep .calibration-history-item .mat-expansion-panel-header-description {
    min-width: 190px;
  }
}
@media (max-width: 600px) {
  .details-page {
    padding: 0.65rem;
    width: 100% !important;
  }
  .instrument-header {
    align-items: stretch;
    flex-direction: column;
    gap: 0.65rem;
    padding: 0.9rem 1rem;
  }
  .removed-badge {
    align-self: center;
    position: static;
  }
  .section-heading {
    flex-direction: column;
  }
  .assignment-form {
    align-items: stretch;
    flex-direction: column;
  }
  .assignment-form .action-button {
    align-self: flex-end;
    height: auto;
    margin-top: -12px;
  }
  .value-comparison {
    grid-template-columns: 1fr;
  }
  .addendum__heading {
    flex-direction: column;
    gap: 6px;
  }
  .addendum__metadata {
    justify-content: flex-start;
  }
  .addendum-form {
    align-items: stretch;
    flex-direction: column;
  }
  .addendum-form .action-button {
    align-self: flex-end;
    min-width: 88px;
  }
  .overview-fields, .period-grid, .record-values {
    grid-template-columns: 1fr;
  }
  .history-filters {
    width: 100%;
    flex-wrap: wrap;
  }
  .history-filters mat-form-field {
    flex: 1 1 100px;
  }
  .calibration-history-item__icon {
    display: none;
  }
  :host ::ng-deep .calibration-history-item .mat-expansion-panel-header {
    min-height: 72px;
    padding: 0 12px;
  }
  :host ::ng-deep .calibration-history-item .mat-expansion-panel-header-title {
    gap: 0;
  }
  :host ::ng-deep .calibration-history-item .mat-expansion-panel-header-description {
    gap: 6px;
    margin-right: 8px;
    min-width: 104px;
  }
  .calibration-history-item__date {
    display: none;
  }
  .attachment-list__header {
    display: none;
  }
  .attachment-list article {
    align-items: start;
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .attachment-maintenance {
    grid-column: 1/-1;
    grid-row: 2;
    padding-left: 36px;
  }
  .attachment-actions {
    grid-column: 2;
    grid-row: 1;
  }
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-equipment/instrument-details.component.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;AACF;;AAEA;EACE,wBAAA;EACA,wBAAA;AACF;;AAEA;EACE,gDAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,aAAA;EACA,cAAA;EACA,oDAAA;EACA,qBAAA;AACF;;AAEA;EAAmB,mBAAA;EAAqB,aAAA;EAAe,8BAAA;EAAgC,SAAA;AAKvF;;AAJA;EAA6B,mBAAA;EAAqB,aAAA;EAAe,WAAA;AAUjE;;AARA;EACE,mBAAA;EACA,2BAAA;EACA,2CAAA;EACA,gCAAA;EACA,oBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AAWF;;AATA;EAAkE,mBAAA;EAAqB,oBAAA;EAAsB,WAAA;EAAY,mBAAA;AAgBzH;;AAfA;EAA6F,kBAAA;EAAoB,eAAA;EAAiB,oBAAA;EAAsB,cAAA;AAsBxJ;;AArBA;;EAEE,qCAAA;EACA,uCAAA;EACA,sBAAA;AAwBF;;AAtBA;EAAwB,kBAAA;EAAoB,eAAA;EAAiB,oBAAA;EAAsB,cAAA;AA6BnF;;AA3BA;EACE,gBAAA;EACA,yBAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AA8BF;;AA3BA;;EAEE,wBAAA;EACA,wBAAA;AA8BF;;AA3BA;EAA4B,cAAA;AA+B5B;;AA9BA;EAA8C,SAAA;AAkC9C;;AAjCA;EAA8B,qBAAA;EAAuB,iBAAA;EAAkB,gBAAA;EAAkB,sBAAA;EAAuB,sBAAA;EAAuB,yBAAA;AA0CvI;;AAzCA;EAAwB,kBAAA;EAAoB,sCAAA;EAAwC,gBAAA;EAAkB,iBAAA;AAgDtG;;AA/CA;EAAwC,uBAAA;EAAyB,kBAAA;EAAmB,mBAAA;AAqDpF;;AApDA;EAAiB,4BAAA;EAA8B,kCAAA;EAAoC,oBAAA;EAAsB,WAAA;EAAa,cAAA;EAAgB,kBAAA;EAAmB,gBAAA;EAAkB,uBAAA;EAAuB,kBAAA;EAAoB,6BAAA;AAiEtN;;AA/DA;EAAe,iBAAA;AAmEf;;AAlEA;EAAqB,aAAA;EAAe,SAAA;EAAW,gDAAA;AAwE/C;;AAvEA;EAAoB,gBAAA;EAAkB,yBAAA;EAA2B,kBAAA;EAAoB,YAAA;EAAc,aAAA;AA+EnG;;AA9EA;EAA0B,iBAAA;AAkF1B;;AAjFA;EAA6B,mBAAA;EAAqB,gCAAA;EAAkC,qBAAA;EAAuB,aAAA;EAAe,QAAA;EAAU,mBAAA;EAAqB,oBAAA;AA2FzJ;;AA1FA;EAAsC,cAAA;AA8FtC;;AA7FA;EAAgC,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,SAAA;AAoGvF;;AAnGA;EAAmB,aAAA;EAAe,cAAA;EAAgB,gDAAA;EAAkD,SAAA;AA0GpG;;AAzGA;EAAyB,YAAA;AA6GzB;;AA5GA;EAAsB,uBAAA;EAAyB,iBAAA;EAAkB,gBAAA;EAAkB,eAAA;EAAiB,yBAAA;AAoHpG;;AAnHA;EAAsB,kBAAA;EAAoB,kBAAA;EAAmB,gBAAA;EAAkB,SAAA;EAAW,uBAAA;AA2H1F;;AA1HA;EAA4B,cAAA;AA8H5B;;AA7HA;EAA0B,aAAA;EAAe,sBAAA;AAkIzC;;AAjIA;EAAqB,6BAAA;EAA+B,gBAAA;EAAkB,iBAAA;AAuItE;;AAtIA;EAA8B,mBAAA;EAAqB,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,8BAAA;EAAgC,mBAAA;AA+I7H;;AA9IA;EAAqC,kBAAA;EAAoB,iBAAA;AAmJzD;;AAlJA;EAAuC,mBAAA;EAAqB,kBAAA;EAAoB,cAAA;EAAgB,qBAAA;EAAuB,kBAAA;EAAmB,gBAAA;EAAkB,gBAAA;EAAkB,gBAAA;AA6J9K;;AA5JA;EAAkB,uBAAA;EAAyB,kBAAA;EAAmB,gBAAA;AAkK9D;;AAjKA;EAAoB,aAAA;EAAe,SAAA;EAAW,2DAAA;AAuK9C;;AAtKA;EAAmB,mBAAA;EAAqB,qCAAA;EAAuC,kBAAA;AA4K/E;;AA3KA;EAAiD,cAAA;AA+KjD;;AA9KA;EAAwB,uBAAA;EAAyB,iBAAA;EAAkB,eAAA;AAoLnE;;AAnLA;EAAqB,eAAA;EAAiB,uBAAA;AAwLtC;;AAtLA;EAAc,aAAA;EAAe,gEAAA;EAAiE,SAAA;AA4L9F;;AA3LA;EAAS,YAAA;EAAc,aAAA;EAAe,yBAAA;EAA2B,iBAAA;AAkMjE;;AAjMA;EAAiC,gBAAA;EAAkB,kBAAA;AAsMnD;;AArMA;EAAe,aAAA;EAAe,mBAAA;EAAqB,SAAA;AA2MnD;;AA1MA;EAA8B,OAAA;AA8M9B;;AA7MA;EAAmB,uBAAA;AAiNnB;;AAhNA;EAAkC,YAAA;EAAc,eAAA;AAqNhD;;AApNA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AAuNF;;AArNA;EACE,gCAAA;EACA,gBAAA;AAwNF;;AAtNA;EAA+E,gBAAA;AA0N/E;;AAzNA;EAAiC,cAAA;EAAgB,iBAAA;EAAmB,mBAAA;AA+NpE;;AA9NA;EAAiB,sBAAA;EAAuB,gBAAA;EAAkB,gBAAA;EAAkB,qBAAA;AAqO5E;;AApOA;EAAyD,0BAAA;EAA4B,gCAAA;EAAkC,WAAA;AA0OvH;;AAzOA;EAAgC,wDAAA;EAA0D,0DAAA;EAA4D,WAAA;AA+OtJ;;AA9OA;EAAyD,gBAAA;EAAkB,gCAAA;EAAkC,qBAAA;AAoP7G;;AAnPA;EAAgC,0BAAA;EAA4B,4BAAA;EAA8B,WAAA;AAyP1F;;AAxPA;EAA0B,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;EAAgB,mBAAA;EAAqB,UAAA;AAgQ3G;;AA/PA;EAAmB,aAAA;EAAe,sBAAA;EAAwB,QAAA;EAAU,UAAA;AAsQpE;;AArQA;EAAsB,mBAAA;EAAqB,aAAA;EAAe,SAAA;EAAW,0CAAA;EAA4C,WAAA;AA6QjH;;AA5QA;EAAsB,mBAAA;EAAqB,oBAAA;EAAsB,QAAA;AAkRjE;;AAjRA;EAAuB,uBAAA;EAAyB,aAAA;EAAe,kBAAA;EAAmB,gBAAA;EAAkB,QAAA;EAAU,yBAAA;AA0R9G;;AAzRA;EAA6B,yBAAA;EAA2B,kBAAA;EAAoB,kBAAA;EAAoB,aAAA;EAAe,gBAAA;EAAkB,oBAAA;AAkSjI;;AAjSA;EAAmB,aAAA;EAAe,sBAAA;EAAwB,YAAA;AAuS1D;;AAtSA;EAAoB,kBAAA;EAAoB,kBAAA;EAAmB,gBAAA;AA4S3D;;AA3SA;EAAmB,mBAAA;EAAqB,wBAAA;EAA0B,SAAA;EAAW,eAAA;AAkT7E;;AAjTA;EAAmB,wDAAA;EAA0D,+DAAA;EAAiE,oBAAA;EAAsB,qBAAA;EAAuB,iBAAA;EAAkB,gBAAA;EAAkB,gBAAA;AA2T/N;;AA1TA;EAAqB,mBAAA;EAAqB,cAAA;EAAgB,oBAAA;EAAsB,kBAAA;EAAmB,QAAA;AAkUnG;;AAjUA;EAA0B,mBAAA;EAAqB,kBAAA;EAAoB,WAAA;EAAa,UAAA;AAwUhF;;AAvUA;EAA+B,uBAAA;AA2U/B;;AA1UA;EAAuD,4BAAA;AA8UvD;;AA7UA;EAA6B,aAAA;AAiV7B;;AAhVA;EAAgB,6BAAA;EAA+B,gBAAA;EAAkB,iBAAA;AAsVjE;;AArVA;EAAuB,uBAAA;EAAyB,aAAA;EAAe,eAAA;EAAiB,kBAAA;EAAmB,aAAA;AA6VnG;;AA5VA;EAA8B,kBAAA;EAAoB,gBAAA;AAiWlD;;AAhWA;EAAsB,mBAAA;EAAqB,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,gBAAA;AAwWrF;;AAvWA;EAAqC,eAAA;AA2WrC;;AA1WA;EAAqC,mBAAA;AA8WrC;;AA7WA;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAgXF;;AA9WA;EAA8B,iBAAA;EAAmB,cAAA;EAAgB,mBAAA;EAAqB,aAAA;AAqXtF;;AApXA;EAA6B,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;AA0XzE;;AAzXA;EAA8B,mBAAA;EAAqB,aAAA;AA8XnD;;AA7XA;EAA0C,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;AAmYtF;;AAlYA;EAAmC,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;AAwY/E;;AAvYA;EAAmC,iCAAA;EAAmC,mBAAA;AA4YtE;;AA3YA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AA8YF;;AA5YA;EAA8B,iBAAA;EAAmB,cAAA;EAAgB,mBAAA;EAAqB,aAAA;AAmZtF;;AAlZA;EAA2B,mBAAA;EAAqB,qBAAA;AAuZhD;;AAtZA;EAAmC,0BAAA;EAA4B,mBAAA;AA2Z/D;;AA1ZA;EAAyB,sBAAA;AA8ZzB;;AA7ZA;EAAe,aAAA;EAAe,gDAAA;EAAkD,SAAA;AAmahF;;AAlaA;EAAqB,iBAAA;AAsarB;;AAraA;EAAuB,iBAAA;EAAmB,iBAAA;EAAqB,mBAAA;EAAqB,kBAAA;AA4apF;;AA3aA;EAAsB,aAAA;EAAe,gDAAA;EAAkD,SAAA;EAAW,kBAAA;AAkblG;;AAjbA;EAA2B,YAAA;AAqb3B;;AApbA;EAAoC,oBAAA;AAwbpC;;AAvbA;EAAiC,aAAA;EAAe,iBAAA;EAAqB,gDAAA;EAAkD,SAAA;AA8bvH;;AA7bA;EAAqB,aAAA;EAAe,yBAAA;AAkcpC;;AAjcA;EAAoC,WAAA;AAqcpC;;AApcA;EAAiB,aAAA;EAAe,8BAAA;EAAgC,SAAA;AA0chE;;AAzcA;EAAsB,qBAAA;EAAuB,kBAAA;EAAmB,gBAAA;AA+chE;;AA9cA;EAAuB,gBAAA;EAAkB,kBAAA;EAAoB,uBAAA;EAAyB,iBAAA;AAqdtF;;AApdA;EAAuB,uCAAA;AAwdvB;;AAvdA;EACE,sDAAA;EACA,sDAAA;EACA,gDAAA;AA0dF;;AAxdA;EACE,sDAAA;EACA,sDAAA;EACA,gDAAA;AA2dF;;AAzdA;EACE,sDAAA;EACA,sDAAA;EACA,gDAAA;AA4dF;;AA1dA;EAA2E,mBAAA;AA8d3E;;AA7dA;EAA0E,mBAAA;AAie1E;;AAheA;EAA4E,mBAAA;AAoe5E;;AAneA;EAAkB,aAAA;EAAe,SAAA;EAAW,eAAA;AAye5C;;AAveA;EAAmB,6BAAA;AA2enB;;AA1eA;EAAmB,aAAA;EAAe,uBAAA;EAAyB,8BAAA;EAAgC,SAAA;AAif3F;;AAhfA;EAAmB,aAAA;EAAe,SAAA;AAqflC;;AApfA;EAAkC,YAAA;AAwflC;;AAvfA;EAA4B,aAAA;EAAe,SAAA;AA4f3C;;AA3fA;EACE,yBAAA;EACA,oEAAA;EACA,6BAAA;EACA,uDAAA;EACA,gBAAA;AA8fF;;AA5fA;EAAyC,iCAAA;EAAmC,wDAAA;AAigB5E;;AAhgBA;EAAkC,mBAAA;EAAqB,wDAAA;EAA0D,kBAAA;EAAoB,qBAAA;EAAuB,oBAAA;EAAsB,cAAA;EAAgB,YAAA;EAAc,uBAAA;AA2gBhN;;AA1gBA;EAA2C,iBAAA;EAAmB,cAAA;EAAgB,mBAAA;EAAqB,aAAA;AAihBnG;;AAhhBA;EAAqC,uBAAA;EAAyB,aAAA;EAAe,sBAAA;EAAwB,QAAA;EAAU,YAAA;AAwhB/G;;AAvhBA;EAA8C,kBAAA;EAAoB,iBAAA;AA4hBlE;;AA3hBA;EAAoC,aAAA;EAAe,eAAA;EAAiB,QAAA;AAiiBpE;;AAhiBA;EAA2C,mBAAA;EAAqB,yBAAA;EAA2B,kBAAA;EAAoB,cAAA;EAAgB,iBAAA;EAAkB,gBAAA;EAAkB,gBAAA;AA0iBnK;;AAziBA;EAAuD,wDAAA;EAA0D,2DAAA;EAA6D,oBAAA;EAAsB,qBAAA;AAgjBpM;;AA/iBA;EAAkC,qBAAA;EAAuB,aAAA;EAAe,sBAAA;EAAwB,QAAA;EAAU,iBAAA;AAujB1G;;AAtjBA;EAAwC,uBAAA;EAAyB,kBAAA;EAAmB,gBAAA;EAAkB,yBAAA;AA6jBtG;;AA5jBA;EAAyC,cAAA;EAAgB,kBAAA;EAAmB,mBAAA;AAkkB5E;;AAjkBA;EAA6B,aAAA;EAAe,QAAA;AAskB5C;;AArkBA;EAA4B,mBAAA;EAAqB,yBAAA;EAA2B,kBAAA;EAAoB,aAAA;EAAe,gCAAA;EAAkC,QAAA;EAAU,gBAAA;EAAkB,mBAAA;AAglB7K;;AA/kBA;EAAkC,cAAA;EAAgB,kBAAA;EAAmB,gBAAA;EAAkB,yBAAA;AAslBvF;;AArlBA;EAAmC,kBAAA;AAylBnC;;AAxlBA;EAAoC,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;AA8lBhF;;AA7lBA;EAAmC,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;AAmmB/E;;AAlmBA;EAAqC,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;AAwmBjF;;AAvmBA;EAAkB,aAAA;EAAe,yBAAA;EAA2B,mBAAA;AA6mB5D;;AA5mBA;EAA2B,mBAAA;EAAqB,oBAAA;EAAsB,QAAA;AAknBtE;;AAjnBA;EAAoC,eAAA;EAAiB,YAAA;EAAc,WAAA;AAunBnE;;AAtnBA;EAAiB,aAAA;EAAe,SAAA;EAAW,gDAAA;AA4nB3C;;AA3nBA;EAAgB,gBAAA;EAAkB,yBAAA;EAA2B,aAAA;EAAe,SAAA;EAAW,aAAA;AAmoBvF;;AAloBA;EAA4B,oCAAA;EAAsC,uDAAA;AAuoBlE;;AAtoBA;EAAyB,uBAAA;EAAyB,aAAA;EAAe,SAAA;EAAW,8BAAA;AA6oB5E;;AA5oBA;EAAgC,uBAAA;EAAyB,iBAAA;EAAkB,gBAAA;EAAkB,yBAAA;AAmpB7F;;AAlpBA;EAAoB,oBAAA;EAAsB,aAAA;EAAe,QAAA;EAAU,gDAAA;EAAkD,mBAAA;AA0pBrH;;AAzpBA;EAA0B,aAAA;EAAe,sBAAA;EAAwB,YAAA;AA+pBjE;;AA9pBA;EAA0B,gBAAA;EAAkB,iBAAA;AAmqB5C;;AAlqBA;EAAyB,uBAAA;EAAyB,iBAAA;EAAkB,gBAAA;EAAkB,yBAAA;AAyqBtF;;AAxqBA;EAA2B,uBAAA;AA4qB3B;;AA3qBA;EAAe,mBAAA;EAAqB,cAAA;EAAgB,oBAAA;EAAsB,kBAAA;EAAmB,gBAAA;EAAkB,QAAA;EAAU,mBAAA;AAqrBzH;;AAprBA;EAAwB,eAAA;EAAiB,YAAA;EAAc,WAAA;AA0rBvD;;AAzrBA;EAAuB,oBAAA;AA6rBvB;;AA5rBA;EAAe,uBAAA;EAAyB,mBAAA;EAAqB,yBAAA;EAA2B,kBAAA;EAAoB,aAAA;EAAe,SAAA;EAAW,0CAAA;EAA4C,gBAAA;EAAkB,kBAAA;AAwsBpM;;AAvsBA;EAAqB,mBAAA;EAAqB,mBAAA;EAAqB,kBAAA;EAAoB,cAAA;EAAgB,oBAAA;EAAsB,YAAA;EAAc,uBAAA;EAAyB,WAAA;AAktBhK;;AAjtBA;EAA8B,eAAA;EAAiB,YAAA;EAAc,iBAAA;EAAmB,WAAA;AAwtBhF;;AAvtBA;EAAsB,cAAA;EAAgB,iBAAA;AA4tBtC;;AA3tBA;EAAiB,cAAA;EAAgB,eAAA;EAAiB,uBAAA;EAAyB,qBAAA;AAkuB3E;;AAjuBA;EAAgB,6BAAA;EAA+B,uBAAA;EAAyB,iBAAA;EAAkB,gBAAA;EAAkB,iBAAA;AAyuB5G;;AAxuBA;EAAyB,kBAAA;AA4uBzB;;AA3uBA;EAAkB,eAAA;EAAiB,uBAAA;AAgvBnC;;AA/uBA;EAAmB,6BAAA;EAA+B,gBAAA;EAAkB,iBAAA;AAqvBpE;;AApvBA;EAAY,uBAAA;EAAyB,mBAAA;EAAqB,yBAAA;EAA2B,qCAAA;EAAuC,kBAAA;EAAoB,aAAA;EAAe,SAAA;EAAW,0CAAA;EAA4C,kBAAA;AAgwBtN;;AA/vBA;EAAwB,gBAAA;AAmwBxB;;AAlwBA;EAAkB,mBAAA;EAAqB,yDAAA;EAA2D,kBAAA;EAAoB,qBAAA;EAAuB,oBAAA;EAAsB,YAAA;EAAc,uBAAA;EAAyB,WAAA;AA6wB1M;;AA5wBA;EAA2B,eAAA;EAAiB,YAAA;EAAc,iBAAA;EAAmB,WAAA;AAmxB7E;;AAlxBA;EAAqB,YAAA;AAsxBrB;;AArxBA;EAAqB,uBAAA;EAAyB,aAAA;EAAe,SAAA;EAAW,8BAAA;AA4xBxE;;AA3xBA;EAA8B,kBAAA;EAAoB,kBAAA;AAgyBlD;;AA/xBA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,aAAA;EAAe,eAAA;EAAiB,kBAAA;EAAmB,aAAA;EAAe,yBAAA;AAyyBtI;;AAxyBA;EAA2B,mBAAA;EAAqB,oBAAA;EAAsB,QAAA;EAAU,mBAAA;AA+yBhF;;AA9yBA;EAAkC,8BAAA;EAAgC,kBAAA;AAmzBlE;;AAlzBA;EAA+B,kBAAA;EAAmB,eAAA;EAAgB,oBAAA;EAAqB,cAAA;AAyzBvF;;AAxzBA;EAAc,cAAA;EAAgB,eAAA;EAAiB,uBAAA;EAAyB,qBAAA;AA+zBxE;;AA9zBA;EAAiB,oBAAA;EAAsB,gBAAA;AAm0BvC;;AAl0BA;EAAgC,SAAA;AAs0BhC;;AAr0BA;EAAgC,YAAA;EAAc,gBAAA;AA00B9C;;AAx0BA;EAAkC,aAAA;EAAe,sBAAA;EAAwB,oBAAA;AA80BzE;;AA70BA;EAAe,SAAA;AAi1Bf;;AAh1BA;EAAkB,SAAA;AAo1BlB;;AAn1BA;EAA8B,SAAA;AAu1B9B;;AAt1BA;EAA+C,qBAAA;AA01B/C;;AAz1BA;EAAuB,WAAA;EAAa,UAAA;EAAY,gBAAA;EAAkB,kBAAA;EAAoB,UAAA;AAi2BtF;;AAh2BA;EACE,mBAAA;EACA,wBAAA;EACA,0BAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;AAm2BF;;AAj2BA;EAAiC,qBAAA;EAAuB,eAAA;EAAiB,YAAA;EAAc,WAAA;AAw2BvF;;AAv2BA;EAA6B,uBAAA;EAAyB,iBAAA;AA42BtD;;AA32BA;;EAC8B,wDAAA;EAA0D,4BAAA;AAg3BxF;;AA/2BA;EAAgC,mBAAA;AAm3BhC;;AAl3BA;EAAgC,mBAAA;EAAqB,aAAA;AAu3BrD;;AAt3BA;EACE,gBAAA;EACA,gCAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAy3BF;;AAv3BA;EAAmD,4BAAA;EAA8B,sEAAA;EAAwE,mBAAA;AA63BzJ;;AA53BA;EAAkB,qBAAA;EAAuB,oBAAA;EAAsB,aAAA;EAAe,sBAAA;EAAwB,YAAA;EAAa,iBAAA;AAq4BnH;;AAp4BA;EAAwB,eAAA;EAAiB,gCAAA;AAy4BzC;;AAx4BA;EAA8B,aAAA;EAAe,8BAAA;EAAgC,SAAA;AA84B7E;;AA74BA;EAAgF,uBAAA;EAAyB,iBAAA;AAk5BzG;;AAj5BA;EAA0B,aAAA;EAAe,qBAAA;AAs5BzC;;AAr5BA;EAA2B,gCAAA;EAAkC,uBAAA;EAAyB,aAAA;EAAe,kBAAA;EAAmB,gBAAA;EAAkB,SAAA;EAAW,iEAAA;EAAkE,gBAAA;EAAkB,yBAAA;AAi6BzO;;AAh6BA;EAA2C,iBAAA;AAo6B3C;;AAn6BA;EAA2B,mBAAA;EAAqB,gCAAA;EAAkC,aAAA;EAAe,SAAA;EAAW,iEAAA;EAAkE,eAAA;AA46B9K;;AA36BA;EAAuB,mBAAA;EAAqB,aAAA;EAAe,SAAA;EAAW,YAAA;AAk7BtE;;AAj7BA;EAAsD,aAAA;EAAe,sBAAA;EAAwB,YAAA;AAu7B7F;;AAt7BA;EAA+B,uBAAA;AA07B/B;;AAz7BA;EAAsB,aAAA;EAAe,QAAA;EAAU,yBAAA;AA+7B/C;;AA97BA;EAA0B,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AAo8BrE;;AAl8BA;EAAiB,qBAAA;AAs8BjB;;AAr8BA;EAAe,mBAAA;EAAqB,sBAAA;EAAuB,oBAAA;EAAsB,uBAAA;EAAyB,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;AA+8B7I;;AA98BA;EAAwB,kBAAA;EAAoB,eAAA;EAAiB,oBAAA;EAAsB,cAAA;AAq9BnF;;AAp9BA;EAAkF,qBAAA;AAw9BlF;;AAv9BA;EACE,gBAAA;EACA,gCAAA;EACA,qBAAA;EACA,eAAA;AA09BF;;AAx9BA;;EAEE,0BAAA;EACA,4BAAA;EACA,WAAA;AA29BF;;AAz9BA;EAAuC,sEAAA;EAAwE,mBAAA;AA89B/G;;AA79BA;EACE,gBAAA;EACA,+BAAA;EACA,oBAAA;AAg+BF;;AA99BA;;EAEE,yBAAA;EACA,2BAAA;EACA,WAAA;AAi+BF;;AA/9BA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,cAAA;EAAgB,kBAAA;EAAoB,oCAAA;EAAsC,wDAAA;EAA0D,oBAAA;AA0+BnM;;AAz+BA;EAAqB,OAAA;AA6+BrB;;AA5+BA;EAAiB,iBAAA;EAAmB,aAAA;EAAe,sBAAA;EAAwB,mBAAA;EAAqB,uBAAA;EAAyB,SAAA;AAq/BzH;;AAp/BA;EAAc,uBAAA;AAw/Bd;;AAt/BA;EACE,gBAAA;EACA,yBAAA;EACA,sBAAA;AAy/BF;;AAt/BA;EAAoD,uBAAA;AA0/BpD;;AAz/BA;EAAqC,oEAAA;AA6/BrC;;AA5/BA;EAA+C,oEAAA;AAggC/C;;AA//BA;EAAoE,iCAAA;EAAmC,gBAAA;AAogCvG;;AAngCA;EAA6D,mDAAA;AAugC7D;;AArgCA;EACE,gEAAA;EACA,6DAAA;EACA,gDAAA;AAwgCF;;AArgCA;EACE,qDAAA;EACA,qDAAA;EACA,+CAAA;EACA,uDAAA;AAwgCF;;AArgCA;EACE,wDAAA;AAwgCF;;AAtgCA;EACE,+CAAA;EACA,yBAAA;EACA,kCAAA;EACA,gBAAA;AAygCF;;AAvgCA;;EACuE,WAAA;AA2gCvE;;AA1gCA;EAA8D,mBAAA;AA8gC9D;;AA7gCA;EACE,iCAAA;AAghCF;;AA9gCA;EAAmC,4DAAA;AAkhCnC;;AAjhCA;EAAwE,gBAAA;EAAkB,eAAA;AAshC1F;;AArhCA;EAA8E,8BAAA;AAyhC9E;;AAxhCA;EAA8E,mBAAA;EAAqB,SAAA;AA6hCnG;;AA5hCA;EAAoF,mBAAA;EAAqB,YAAA;EAAc,SAAA;EAAW,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;AAqiCjL;;AApiCA;EAAsE,6BAAA;EAA+B,aAAA;AAyiCrG;;AAviCA;EAAa,aAAA;EAAe,SAAA;AA4iC5B;;AA3iCA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,YAAA;EAAa,yDAAA;AAkjC5E;;AAjjCA;EAA0C,WAAA;AAqjC1C;;AApjCA;EAAoB,gBAAA;AAwjCpB;;AAvjCA;EAAmB,yBAAA;EAA2B,gBAAA;EAAkB,WAAA;AA6jChE;;AA5jCA;EAA2C,gCAAA;EAAkC,sBAAA;EAAsB,gBAAA;EAAkB,sBAAA;AAmkCrH;;AAlkCA;EAAsB,cAAA;EAAgB,kBAAA;EAAmB,yBAAA;AAwkCzD;;AAvkCA;EAAgC,mBAAA;AA2kChC;;AA1kCA;EAAmB,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;EAAkB,gBAAA;EAAiB,WAAA;AAklCrG;;AAjlCA;EAAgB,mBAAA;EAAqB,oBAAA;EAAsB,cAAA;EAAgB,qBAAA;EAAuB,kBAAA;EAAmB,gBAAA;EAAkB,uBAAA;EAAuB,mBAAA;AA4lC9J;;AA3lCA;EAAwB,mBAAA;EAAqB,cAAA;AAgmC7C;;AA/lCA;EAAyB,mBAAA;AAmmCzB;;AAjmCA;EACE;IAAqB,0BAAA;EAqmCrB;EApmCA;IAA0B,iBAAA;EAumC1B;EAtmCA;IAAc,0BAAA;EAymCd;EAxmCA;IAAsD,0BAAA;EA2mCtD;EA1mCA;IAAiB,0BAAA;EA6mCjB;EA5mCA;IAAkC,aAAA;EA+mClC;EA9mCA;IAAoF,gBAAA;EAinCpF;AACF;AA/mCA;EACE;IAAgB,gBAAA;IAAiB,sBAAA;EAmnCjC;EAlnCA;IAAqB,oBAAA;IAAsB,sBAAA;IAAwB,YAAA;IAAa,oBAAA;EAwnChF;EAvnCA;IAAiB,kBAAA;IAAoB,gBAAA;EA2nCrC;EA1nCA;IAAmB,sBAAA;EA6nCnB;EA5nCA;IAAmB,oBAAA;IAAsB,sBAAA;EAgoCzC;EA/nCA;IAAkC,oBAAA;IAAsB,YAAA;IAAc,iBAAA;EAooCtE;EAnoCA;IAAoB,0BAAA;EAsoCpB;EAroCA;IAAqB,sBAAA;IAAwB,QAAA;EAyoC7C;EAxoCA;IAAsB,2BAAA;EA2oCtB;EA1oCA;IAAiB,oBAAA;IAAsB,sBAAA;EA8oCvC;EA7oCA;IAAgC,oBAAA;IAAsB,eAAA;EAipCtD;EAhpCA;IAAiD,0BAAA;EAmpCjD;EAlpCA;IAAmB,WAAA;IAAa,eAAA;EAspChC;EArpCA;IAAkC,eAAA;EAwpClC;EAvpCA;IAAkC,aAAA;EA0pClC;EAzpCA;IAAwE,gBAAA;IAAkB,eAAA;EA6pC1F;EA5pCA;IAA8E,MAAA;EA+pC9E;EA9pCA;IAAoF,QAAA;IAAU,iBAAA;IAAmB,gBAAA;EAmqCjH;EAlqCA;IAAkC,aAAA;EAqqClC;EApqCA;IAA2B,aAAA;EAuqC3B;EAtqCA;IAA2B,kBAAA;IAAoB,0CAAA;EA0qC/C;EAzqCA;IAA0B,iBAAA;IAAqB,WAAA;IAAa,kBAAA;EA8qC5D;EA7qCA;IAAsB,cAAA;IAAgB,WAAA;EAirCtC;AACF","sourcesContent":[":host {\n  --nextpage-tab-active: #0b2d71;\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.btn::after {\n  content: none !important;\n  display: none !important;\n}\n\n.details-page {\n  background: var(--background-gray, var(--light));\n  box-sizing: border-box;\n  flex: 1 1 auto;\n  margin: 0 auto !important;\n  max-width: 1920px !important;\n  min-height: 0;\n  overflow: auto;\n  padding: 0.65rem clamp(0.65rem, 2vw, 1.4rem) 0.75rem;\n  width: 96% !important;\n}\n\n.details-actions { align-items: center; display: flex; justify-content: space-between; gap: 1rem; }\n.details-actions__commands { align-items: center; display: flex; gap: .6rem; }\n\n.back-action {\n  align-items: center;\n  background: #fff !important;\n  border: 1px solid var(--primary) !important;\n  color: var(--primary) !important;\n  display: inline-flex;\n  gap: .5rem;\n  margin: 0 0 .65rem;\n  padding: .45rem .8rem;\n}\n.edit-action, .move-to-removed-action, .permanent-delete-action { align-items: center; display: inline-flex; gap: .5rem; margin: 0 0 .65rem; }\n.edit-action mat-icon, .move-to-removed-action mat-icon, .permanent-delete-action mat-icon { font-size: 1.15rem; height: 1.15rem; line-height: 1.15rem; width: 1.15rem; }\n.back-action:hover,\n.back-action:focus-visible {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n  color: #fff !important;\n}\n.back-action mat-icon { font-size: 1.15rem; height: 1.15rem; line-height: 1.15rem; width: 1.15rem; }\n\n.instrument-header {\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-left: 4px solid var(--primary);\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 0 1.2rem !important;\n  max-width: none !important;\n  min-height: 58px !important;\n  padding: .9rem clamp(1rem, 3vw, 2rem);\n  position: relative;\n  text-align: center;\n  width: auto !important;\n}\n\n.instrument-header::before,\n.instrument-header::after {\n  content: none !important;\n  display: none !important;\n}\n\n.instrument-header__title { flex: 1 1 auto; }\n.instrument-header p, .instrument-header h1 { margin: 0; }\n.instrument-header .eyebrow { color: var(--primary); font-size: .7rem; font-weight: 700; letter-spacing: .08em; margin-bottom: .15rem; text-transform: uppercase; }\n.instrument-header h1 { color: var(--dark); font-size: clamp(1.3rem, 2vw, 1.65rem); font-weight: 700; line-height: 1.15; }\n.instrument-header .page-introduction { color: var(--secondary); font-size: .82rem; margin-top: .25rem; }\n.removed-badge { background: var(--secondary); border: 1px solid var(--secondary); border-radius: 999px; color: #fff; flex: 0 0 auto; font-size: .72rem; font-weight: 700; padding: .35rem .7rem; position: absolute; right: clamp(1rem, 3vw, 2rem); }\n\n.tab-content { padding: 24px 4px; }\n.overview-sections { display: grid; gap: 16px; grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.overview-section { background: #fff; border: 1px solid #dee2e6; border-radius: 5px; min-width: 0; padding: 18px; }\n.overview-section--wide { grid-column: 1 / -1; }\n.overview-section__heading { align-items: center; border-bottom: 1px solid #e9ecef; color: var(--primary); display: flex; gap: 9px; margin-bottom: 14px; padding-bottom: 11px; }\n.overview-section__heading mat-icon { flex: 0 0 auto; }\n.overview-section__heading h2 { color: var(--dark); font-size: 1rem; font-weight: 700; margin: 0; }\n.overview-fields { display: grid; gap: 14px 18px; grid-template-columns: repeat(2, minmax(0, 1fr)); margin: 0; }\n.overview-fields > div { min-width: 0; }\n.overview-fields dt { color: var(--secondary); font-size: .7rem; font-weight: 700; margin: 0 0 4px; text-transform: uppercase; }\n.overview-fields dd { color: var(--dark); font-size: .88rem; font-weight: 600; margin: 0; overflow-wrap: anywhere; }\n.overview-fields--compact { gap: 11px 14px; }\n.overview-schedule-list { display: flex; flex-direction: column; }\n.overview-schedule { border-top: 1px solid #e9ecef; margin-top: 14px; padding-top: 12px; }\n.overview-schedule__heading { align-items: center; display: flex; flex-wrap: wrap; gap: 8px; justify-content: space-between; margin-bottom: 10px; }\n.overview-schedule__heading strong { color: var(--dark); font-size: .9rem; }\n.overview-inactive, .overview-manual { background: #f1f3f5; border-radius: 3px; color: #5c6770; display: inline-block; font-size: .68rem; font-weight: 700; margin-left: 5px; padding: 2px 6px; }\n.overview-empty { color: var(--secondary); font-size: .84rem; margin: 12px 0 0; }\n.lifecycle-events { display: grid; gap: 10px; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); }\n.lifecycle-event { background: #f8f9fa; border-left: 3px solid var(--primary); padding: 11px 13px; }\n.lifecycle-event strong, .lifecycle-event span { display: block; }\n.lifecycle-event span { color: var(--secondary); font-size: .8rem; margin-top: 3px; }\n.lifecycle-event p { margin: 7px 0 0; overflow-wrap: anywhere; }\n\n.two-column { display: grid; grid-template-columns: minmax(280px, .8fr) minmax(400px, 1.4fr); gap: 20px; }\n.panel { min-width: 0; padding: 20px; border: 1px solid #dee2e6; background: white; }\n.panel h2, .section-heading h2 { margin: 0 0 18px; font-size: 1.15rem; }\n.inline-form { display: flex; align-items: center; gap: 10px; }\n.inline-form mat-form-field { flex: 1; }\n.assignment-form { align-items: flex-start; }\n.assignment-form .action-button { height: 56px; margin-top: 4px; }\n::ng-deep .calibration-item-select-panel .mat-mdc-optgroup-label {\n  background: #f1f3f5;\n  color: #495057;\n  font-size: .72rem;\n  font-weight: 700;\n  letter-spacing: .04em;\n  min-height: 34px;\n  text-transform: uppercase;\n}\n::ng-deep .calibration-item-select-panel .calibration-item-option {\n  border-bottom: 1px solid #e9ecef;\n  min-height: 48px;\n}\n::ng-deep .calibration-item-select-panel .calibration-item-option:last-child { border-bottom: 0; }\n.calibration-item-option__name { display: block; line-height: 1.25; white-space: normal; }\n.action-button { border-radius: .25rem; font-weight: 600; min-height: 38px; padding: .45rem 1rem; }\n.action-button--primary, .action-button--primary:focus { background: var(--primary); border: 1px solid var(--primary); color: #fff; }\n.action-button--primary:hover { background: color-mix(in srgb, var(--primary) 86%, #000); border-color: color-mix(in srgb, var(--primary) 86%, #000); color: #fff; }\n.action-button--outline, .action-button--outline:focus { background: #fff; border: 1px solid var(--primary); color: var(--primary); }\n.action-button--outline:hover { background: var(--primary); border-color: var(--primary); color: #fff; }\n.action-button:disabled { background: #e9ecef; border-color: #ced4da; color: #6c757d; cursor: not-allowed; opacity: 1; }\n.assignment-list { display: flex; flex-direction: column; gap: 8px; padding: 0; }\n.assignment-content { align-items: center; display: grid; gap: 12px; grid-template-columns: minmax(0, 1fr) auto; width: 100%; }\n.assignment-actions { align-items: center; display: inline-flex; gap: 8px; }\n.activation-due-date { color: var(--secondary); display: grid; font-size: .68rem; font-weight: 700; gap: 2px; text-transform: uppercase; }\n.activation-due-date input { border: 1px solid #adb5bd; border-radius: 4px; color: var(--dark); font: inherit; padding: 5px 7px; text-transform: none; }\n.assignment-copy { display: flex; flex-direction: column; min-width: 0; }\n.assignment-title { color: var(--dark); font-size: .92rem; font-weight: 700; }\n.assignment-meta { align-items: center; display: flex !important; gap: 10px; margin-top: 5px; }\n.frequency-badge { background: color-mix(in srgb, var(--primary) 9%, white); border: 1px solid color-mix(in srgb, var(--primary) 25%, white); border-radius: 999px; color: var(--primary); font-size: .7rem; font-weight: 700; padding: 2px 8px; }\n.assignment-status { align-items: center; color: #276749; display: inline-flex; font-size: .75rem; gap: 5px; }\n.assignment-status__dot { background: #2f855a; border-radius: 50%; height: 7px; width: 7px; }\n.assignment-status--inactive { color: var(--secondary); }\n.assignment-status--inactive .assignment-status__dot { background: var(--secondary); }\n.assignment-item--inactive { opacity: .72; }\n.due-override { border-top: 1px solid #dee2e6; margin-top: 16px; padding-top: 16px; }\n.due-override__dates { color: var(--secondary); display: flex; flex-wrap: wrap; font-size: .82rem; gap: 8px 20px; }\n.due-override__dates strong { color: var(--dark); margin-left: 5px; }\n.due-override__form { align-items: center; display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }\n.due-override__form mat-form-field { flex: 1 1 155px; }\n.due-override__form .action-button { margin-bottom: 20px; }\n.assignment-toggle {\n  align-items: center;\n  align-self: center;\n  background: #f1f3f5;\n  border: 1px solid #adb5bd;\n  border-radius: 50%;\n  color: #6c757d;\n  cursor: pointer;\n  display: inline-flex;\n  height: 38px;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  width: 38px;\n}\n.assignment-toggle mat-icon { font-size: 1.5rem; height: 1.5rem; line-height: 1.5rem; width: 1.5rem; }\n.assignment-toggle--active { background: #edf7f1; border-color: #8bc6a4; color: #276749; }\n.assignment-toggle:disabled { cursor: not-allowed; opacity: .45; }\n.assignment-toggle:not(:disabled):hover { background: #e2e6ea; border-color: #6c757d; color: #495057; }\n.assignment-toggle--active:hover { background: #dff2e7; border-color: #2f855a; color: #1f5c3d; }\n.assignment-toggle:focus-visible { outline: 2px solid var(--primary); outline-offset: 2px; }\n.assignment-delete {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e3a5ab;\n  border-radius: 50%;\n  color: #c82333;\n  cursor: pointer;\n  display: inline-flex;\n  height: 38px;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  width: 38px;\n}\n.assignment-delete mat-icon { font-size: 1.3rem; height: 1.3rem; line-height: 1.3rem; width: 1.3rem; }\n.assignment-delete:hover { background: #fbe9eb; border-color: #c82333; }\n.assignment-delete:focus-visible { outline: 2px solid #c82333; outline-offset: 2px; }\n.nextpage-panel-action { align-self: flex-start; }\n.period-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }\n.period-grid .wide { grid-column: 1 / -1; }\n.record-type-control { align-self: start; grid-column: 1 / -1; justify-self: start; margin-bottom: 4px; }\n.calibration-fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin: 6px 0 14px; }\n.calibration-field-group { min-width: 0; }\n.calibration-field-group--new-row { grid-column-start: 1; }\n.calibration-field-group--pair { display: grid; grid-column: 1 / -1; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }\n.calibration-field { padding: 14px; border: 1px solid #dee2e6; }\n.calibration-field mat-form-field { width: 100%; }\n.field-heading { display: flex; justify-content: space-between; gap: 10px; }\n.field-heading span { color: var(--primary); font-size: .75rem; font-weight: 700; }\n.calibration-field p { min-height: 34px; margin: 5px 0 10px; color: var(--secondary); font-size: .8rem; }\n.numeric-value-field { transition: background-color .15s ease; }\n.numeric-value-field--target {\n  --mdc-outlined-text-field-focus-outline-color: #2f855a;\n  --mdc-outlined-text-field-hover-outline-color: #2f855a;\n  --mdc-outlined-text-field-outline-color: #68a980;\n}\n.numeric-value-field--range {\n  --mdc-outlined-text-field-focus-outline-color: #2879a8;\n  --mdc-outlined-text-field-hover-outline-color: #2879a8;\n  --mdc-outlined-text-field-outline-color: #6ca6c7;\n}\n.numeric-value-field--outside {\n  --mdc-outlined-text-field-focus-outline-color: #b42318;\n  --mdc-outlined-text-field-hover-outline-color: #b42318;\n  --mdc-outlined-text-field-outline-color: #d66b63;\n}\n:host ::ng-deep .numeric-value-field--target .mat-mdc-text-field-wrapper { background: #edf8f1; }\n:host ::ng-deep .numeric-value-field--range .mat-mdc-text-field-wrapper { background: #eef6fb; }\n:host ::ng-deep .numeric-value-field--outside .mat-mdc-text-field-wrapper { background: #fff1f0; }\nmat-radio-group { display: flex; gap: 20px; padding: 12px 0; }\n\n.history-section { border-top: 1px solid #dee2e6; }\n.section-heading { display: flex; align-items: flex-start; justify-content: space-between; gap: 20px; }\n.history-filters { display: flex; gap: 10px; }\n.history-filters mat-form-field { width: 120px; }\n.calibration-history-list { display: grid; gap: 10px; }\n.calibration-history-item {\n  border: 1px solid #d7dce1;\n  border-left: 4px solid color-mix(in srgb, var(--primary) 55%, white);\n  border-radius: 6px !important;\n  box-shadow: 0 1px 2px rgba(33, 37, 41, .08) !important;\n  overflow: hidden;\n}\n.calibration-history-item.mat-expanded { border-left-color: var(--primary); box-shadow: 0 3px 10px rgba(33, 37, 41, .11) !important; }\n.calibration-history-item__icon { align-items: center; background: color-mix(in srgb, var(--primary) 9%, white); border-radius: 50%; color: var(--primary); display: inline-flex; flex: 0 0 36px; height: 36px; justify-content: center; }\n.calibration-history-item__icon mat-icon { font-size: 1.2rem; height: 1.2rem; line-height: 1.2rem; width: 1.2rem; }\n.calibration-history-item__summary { align-items: flex-start; display: flex; flex-direction: column; gap: 5px; min-width: 0; }\n.calibration-history-item__summary > strong { color: var(--dark); font-size: .9rem; }\n.calibration-history-item__period { display: flex; flex-wrap: wrap; gap: 6px; }\n.calibration-history-item__period > span { background: #f1f3f5; border: 1px solid #dee2e6; border-radius: 3px; color: #495057; font-size: .7rem; font-weight: 700; padding: 2px 7px; }\n.calibration-history-item__period > .frequency-badge { background: color-mix(in srgb, var(--primary) 9%, white); border-color: color-mix(in srgb, var(--primary) 25%, white); border-radius: 999px; color: var(--primary); }\n.calibration-history-item__date { align-items: flex-end; display: flex; flex-direction: column; gap: 2px; text-align: right; }\n.calibration-history-item__date small { color: var(--secondary); font-size: .65rem; font-weight: 700; text-transform: uppercase; }\n.calibration-history-item__date strong { color: #495057; font-size: .82rem; white-space: nowrap; }\n.calibration-status-counts { display: flex; gap: 5px; }\n.calibration-status-count { align-items: center; border: 1px solid #ced4da; border-radius: 3px; display: grid; grid-template-columns: auto auto; gap: 5px; padding: 3px 6px; white-space: nowrap; }\n.calibration-status-count small { color: #59636d; font-size: .62rem; font-weight: 700; text-transform: uppercase; }\n.calibration-status-count strong { font-size: .75rem; }\n.calibration-status-count--target { background: #edf8f1; border-color: #a9d8b8; color: #276749; }\n.calibration-status-count--range { background: #eef6fb; border-color: #acd0e5; color: #245b78; }\n.calibration-status-count--outside { background: #fff1f0; border-color: #e5b4b0; color: #a52a2a; }\n.record-actions { display: flex; justify-content: flex-end; margin-bottom: 12px; }\n.edit-calibration-action { align-items: center; display: inline-flex; gap: 6px; }\n.edit-calibration-action mat-icon { font-size: 1rem; height: 1rem; width: 1rem; }\n.record-values { display: grid; gap: 10px; grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.record-value { background: #fff; border: 1px solid #dee2e6; display: grid; gap: 12px; padding: 14px; }\n.record-value.out-of-spec { border-left: 4px solid var(--danger); background: color-mix(in srgb, var(--danger) 5%, white); }\n.record-value__heading { align-items: flex-start; display: flex; gap: 12px; justify-content: space-between; }\n.record-value__heading > span { color: var(--secondary); font-size: .7rem; font-weight: 700; text-transform: uppercase; }\n.value-comparison { align-items: stretch; display: grid; gap: 1px; grid-template-columns: repeat(3, minmax(0, 1fr)); background: #dee2e6; }\n.value-comparison > div { display: flex; flex-direction: column; min-width: 0; }\n.value-comparison > div { background: #fff; padding: 8px 10px; }\n.value-comparison span { color: var(--secondary); font-size: .7rem; font-weight: 700; text-transform: uppercase; }\n.value-comparison strong { overflow-wrap: anywhere; }\n.spec-status { align-items: center; color: #276749; display: inline-flex; font-size: .75rem; font-weight: 700; gap: 5px; justify-self: start; }\n.spec-status mat-icon { font-size: 1rem; height: 1rem; width: 1rem; }\n.spec-status--failed { color: var(--danger); }\n.record-note { align-items: flex-start; background: #fffaf0; border: 1px solid #e5d4a6; border-radius: 4px; display: grid; gap: 11px; grid-template-columns: 30px minmax(0, 1fr); margin-top: 16px; padding: 12px 14px; }\n.record-note__icon { align-items: center; background: #f5e9c8; border-radius: 50%; color: #725600; display: inline-flex; height: 30px; justify-content: center; width: 30px; }\n.record-note__icon mat-icon { font-size: 1rem; height: 1rem; line-height: 1rem; width: 1rem; }\n.record-note strong { color: #4f410f; font-size: .8rem; }\n.record-note p { color: #3f3a2b; margin: 5px 0 0; overflow-wrap: anywhere; white-space: pre-wrap; }\n.date-changes { border-top: 1px solid #dee2e6; color: var(--secondary); font-size: .8rem; margin-top: 16px; padding-top: 12px; }\n.date-changes > strong { color: var(--dark); }\n.date-changes p { margin: 8px 0 0; overflow-wrap: anywhere; }\n.addenda-section { border-top: 1px solid #e1e5e9; margin-top: 20px; padding-top: 16px; }\n.addendum { align-items: flex-start; background: #f8f9fa; border: 1px solid #dfe3e7; border-left: 3px solid var(--primary); border-radius: 4px; display: grid; gap: 12px; grid-template-columns: 32px minmax(0, 1fr); padding: 13px 14px; }\n.addendum + .addendum { margin-top: 10px; }\n.addendum__icon { align-items: center; background: color-mix(in srgb, var(--primary) 10%, white); border-radius: 50%; color: var(--primary); display: inline-flex; height: 32px; justify-content: center; width: 32px; }\n.addendum__icon mat-icon { font-size: 1rem; height: 1rem; line-height: 1rem; width: 1rem; }\n.addendum__content { min-width: 0; }\n.addendum__heading { align-items: flex-start; display: flex; gap: 12px; justify-content: space-between; }\n.addendum__heading > strong { color: var(--dark); font-size: .86rem; }\n.addendum__metadata { align-items: center; color: var(--secondary); display: flex; flex-wrap: wrap; font-size: .72rem; gap: 4px 10px; justify-content: flex-end; }\n.addendum__metadata span { align-items: center; display: inline-flex; gap: 4px; white-space: nowrap; }\n.addendum__metadata span + span { border-left: 1px solid #ced4da; padding-left: 10px; }\n.addendum__metadata mat-icon { font-size: .85rem; height: .85rem; line-height: .85rem; width: .85rem; }\n.addendum p { color: #343a40; margin: 9px 0 0; overflow-wrap: anywhere; white-space: pre-wrap; }\n.addendum-form { align-items: stretch; margin-top: 14px; }\n.addendum-form mat-form-field { margin: 0; }\n.addendum-form .action-button { height: 56px; min-height: 56px; }\n\n.maintenance-form, .upload-form { display: flex; flex-direction: column; align-items: stretch; }\n.upload-form { gap: 1rem; }\n.upload-form h2 { margin: 0; }\n.upload-form mat-form-field { margin: 0; }\n.upload-form mat-form-field + mat-form-field { margin-top: -.375rem; }\n.document-file-input { height: 1px; opacity: 0; overflow: hidden; position: absolute; width: 1px; }\n.document-drop-zone {\n  align-items: center;\n  background: var(--light);\n  border: 2px dashed #9aa8b6;\n  border-radius: .25rem;\n  box-sizing: border-box;\n  color: var(--dark);\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: .35rem;\n  justify-content: center;\n  min-height: 170px;\n  padding: 1.25rem;\n  text-align: center;\n  transition: background-color .15s ease, border-color .15s ease;\n}\n.document-drop-zone > mat-icon { color: var(--primary); font-size: 2rem; height: 2rem; width: 2rem; }\n.document-drop-zone > span { color: var(--secondary); font-size: .8rem; }\n.document-drop-zone:hover,\n.document-drop-zone--active { background: color-mix(in srgb, var(--primary) 7%, white); border-color: var(--primary); }\n.document-drop-zone--selected { border-style: solid; }\n.document-drop-zone--disabled { cursor: not-allowed; opacity: .65; }\n.document-drop-zone__action {\n  background: #fff;\n  border: 1px solid var(--primary);\n  border-radius: .25rem;\n  color: var(--primary) !important;\n  font-size: .875rem !important;\n  font-weight: 600;\n  margin-top: .35rem;\n  padding: .4rem .75rem;\n}\n.document-file-input:focus + .document-drop-zone { border-color: var(--primary); outline: 2px solid color-mix(in srgb, var(--primary) 35%, transparent); outline-offset: 2px; }\n.upload-actions { align-items: flex-end; align-self: flex-end; display: flex; flex-direction: column; gap: .25rem; text-align: right; }\n.history-list article { padding: 14px 0; border-bottom: 1px solid #dee2e6; }\n.history-list article > div { display: flex; justify-content: space-between; gap: 12px; }\n.history-list article span, .attachment-list article span, .upload-form small { color: var(--secondary); font-size: .8rem; }\n.history-list article p { margin: 8px 0; white-space: pre-wrap; }\n.attachment-list__header { border-bottom: 1px solid #adb5bd; color: var(--secondary); display: grid; font-size: .72rem; font-weight: 700; gap: 16px; grid-template-columns: minmax(0, 1.4fr) minmax(140px, .8fr) 84px; padding: 0 0 8px; text-transform: uppercase; }\n.attachment-list__header span:last-child { text-align: right; }\n.attachment-list article { align-items: center; border-bottom: 1px solid #dee2e6; display: grid; gap: 16px; grid-template-columns: minmax(0, 1.4fr) minmax(140px, .8fr) 84px; padding: 12px 0; }\n.attachment-document { align-items: center; display: flex; gap: 12px; min-width: 0; }\n.attachment-document > div, .attachment-maintenance { display: flex; flex-direction: column; min-width: 0; }\n.attachment-maintenance span { overflow-wrap: anywhere; }\n.attachment-actions { display: flex; gap: 8px; justify-content: flex-end; }\n.attachment-list strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n.document-icon { color: var(--primary); }\n.icon-action { align-items: center; border-radius: .25rem; display: inline-flex; justify-content: center; min-height: 34px; min-width: 34px; padding: .25rem; }\n.icon-action mat-icon { font-size: 1.25rem; height: 1.25rem; line-height: 1.25rem; width: 1.25rem; }\n.icon-action--primary, .icon-action--primary:hover, .icon-action--primary:focus { color: var(--primary); }\n.icon-action--download {\n  background: #fff;\n  border: 1px solid var(--primary);\n  color: var(--primary);\n  cursor: pointer;\n}\n.icon-action--download:hover,\n.icon-action--download:focus-visible {\n  background: var(--primary);\n  border-color: var(--primary);\n  color: #fff;\n}\n.icon-action--download:focus-visible { outline: 2px solid color-mix(in srgb, var(--primary) 35%, transparent); outline-offset: 2px; }\n.icon-action--danger {\n  background: #fff;\n  border: 1px solid var(--danger);\n  color: var(--danger);\n}\n.icon-action--danger:hover,\n.icon-action--danger:focus-visible {\n  background: var(--danger);\n  border-color: var(--danger);\n  color: #fff;\n}\n.error-banner { display: flex; align-items: center; gap: 10px; margin: 12px 0; padding: 10px 14px; border-left: 4px solid var(--danger); background: color-mix(in srgb, var(--danger) 10%, white); color: var(--danger); }\n.error-banner span { flex: 1; }\n.loading-state { min-height: 300px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; }\n.empty-copy { color: var(--secondary); }\n\n:host ::ng-deep .mat-mdc-tab-header {\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: .25rem;\n}\n\n:host ::ng-deep .mat-mdc-tab .mdc-tab__text-label { color: var(--secondary); }\n:host ::ng-deep .mat-mdc-tab:hover { background: color-mix(in srgb, var(--nextpage-tab-active) 5%, white); }\n:host ::ng-deep .mat-mdc-tab.mdc-tab--active { background: color-mix(in srgb, var(--nextpage-tab-active) 9%, white); }\n:host ::ng-deep .mat-mdc-tab.mdc-tab--active .mdc-tab__text-label { color: var(--nextpage-tab-active); font-weight: 700; }\n:host ::ng-deep .mat-mdc-tab-indicator__content--underline { border-color: var(--nextpage-tab-active) !important; }\n\n:host ::ng-deep .mat-mdc-form-field {\n  --mdc-outlined-text-field-focus-label-text-color: var(--primary);\n  --mdc-outlined-text-field-focus-outline-color: var(--primary);\n  --mat-select-focused-arrow-color: var(--primary);\n}\n\n:host ::ng-deep .mat-mdc-radio-button {\n  --mdc-radio-selected-focus-icon-color: var(--primary);\n  --mdc-radio-selected-hover-icon-color: var(--primary);\n  --mdc-radio-selected-icon-color: var(--primary);\n  --mdc-radio-selected-pressed-icon-color: var(--primary);\n}\n\n:host ::ng-deep .mat-mdc-list-option.mdc-list-item--selected {\n  background: color-mix(in srgb, var(--primary) 8%, white);\n}\n:host ::ng-deep .assignment-list .mat-mdc-list-option {\n  --mat-radio-selected-icon-color: var(--primary);\n  border: 1px solid #dee2e6;\n  border-left: 3px solid transparent;\n  min-height: 76px;\n}\n:host ::ng-deep .assignment-list .mdc-list-item__content,\n:host ::ng-deep .assignment-list .mat-mdc-list-item-unscoped-content { width: 100%; }\n:host ::ng-deep .assignment-list .mat-mdc-list-option:hover { background: #f8f9fa; }\n:host ::ng-deep .assignment-list .mat-mdc-list-option.mdc-list-item--selected {\n  border-left-color: var(--primary);\n}\n:host ::ng-deep mat-progress-bar { --mdc-linear-progress-active-indicator-color: var(--primary); }\n:host ::ng-deep .calibration-history-item .mat-expansion-panel-header { min-height: 68px; padding: 0 18px; }\n:host ::ng-deep .calibration-history-item .mat-expansion-panel-header:hover { background: #f8f9fa !important; }\n:host ::ng-deep .calibration-history-item .mat-expansion-panel-header-title { align-items: center; gap: 12px; }\n:host ::ng-deep .calibration-history-item .mat-expansion-panel-header-description { align-items: center; flex-grow: 0; gap: 14px; justify-content: flex-end; margin-right: 18px; min-width: 430px; }\n:host ::ng-deep .calibration-history-item .mat-expansion-panel-body { border-top: 1px solid #e9ecef; padding: 18px; }\n\n.blade-log { display: grid; gap: 1rem; }\n.blade-installation-form { align-items: center; display: grid; gap: .75rem; grid-template-columns: repeat(3, minmax(150px, 1fr)) auto; }\n.blade-installation-form mat-form-field { width: 100%; }\n.table-responsive { overflow-x: auto; }\n.blade-log-table { border-collapse: collapse; min-width: 940px; width: 100%; }\n.blade-log-table th, .blade-log-table td { border-bottom: 1px solid #d9e1e8; padding: .7rem .6rem; text-align: left; vertical-align: middle; }\n.blade-log-table th { color: #455a64; font-size: .78rem; text-transform: uppercase; }\n.blade-log-table__out-of-spec { background: #fff2f2; }\n.blade-log-input { border: 1px solid #aebbc5; border-radius: 4px; max-width: 145px; padding: .45rem; width: 100%; }\n.blade-status { background: #e7f4eb; border-radius: 999px; color: #236437; display: inline-block; font-size: .82rem; font-weight: 600; padding: .3rem .55rem; white-space: nowrap; }\n.blade-status--failed { background: #fde5e5; color: #a11f1f; }\n.blade-complete-action { white-space: nowrap; }\n\n@media (max-width: 900px) {\n  .overview-sections { grid-template-columns: 1fr; }\n  .overview-section--wide { grid-column: auto; }\n  .two-column { grid-template-columns: 1fr; }\n  .calibration-fields, .calibration-field-group--pair { grid-template-columns: 1fr; }\n  .record-values { grid-template-columns: 1fr; }\n  .calibration-status-count small { display: none; }\n  :host ::ng-deep .calibration-history-item .mat-expansion-panel-header-description { min-width: 190px; }\n}\n\n@media (max-width: 600px) {\n  .details-page { padding: .65rem; width: 100% !important; }\n  .instrument-header { align-items: stretch; flex-direction: column; gap: .65rem; padding: .9rem 1rem; }\n  .removed-badge { align-self: center; position: static; }\n  .section-heading { flex-direction: column; }\n  .assignment-form { align-items: stretch; flex-direction: column; }\n  .assignment-form .action-button { align-self: flex-end; height: auto; margin-top: -12px; }\n  .value-comparison { grid-template-columns: 1fr; }\n  .addendum__heading { flex-direction: column; gap: 6px; }\n  .addendum__metadata { justify-content: flex-start; }\n  .addendum-form { align-items: stretch; flex-direction: column; }\n  .addendum-form .action-button { align-self: flex-end; min-width: 88px; }\n  .overview-fields, .period-grid, .record-values { grid-template-columns: 1fr; }\n  .history-filters { width: 100%; flex-wrap: wrap; }\n  .history-filters mat-form-field { flex: 1 1 100px; }\n  .calibration-history-item__icon { display: none; }\n  :host ::ng-deep .calibration-history-item .mat-expansion-panel-header { min-height: 72px; padding: 0 12px; }\n  :host ::ng-deep .calibration-history-item .mat-expansion-panel-header-title { gap: 0; }\n  :host ::ng-deep .calibration-history-item .mat-expansion-panel-header-description { gap: 6px; margin-right: 8px; min-width: 104px; }\n  .calibration-history-item__date { display: none; }\n  .attachment-list__header { display: none; }\n  .attachment-list article { align-items: start; grid-template-columns: minmax(0, 1fr) auto; }\n  .attachment-maintenance { grid-column: 1 / -1; grid-row: 2; padding-left: 36px; }\n  .attachment-actions { grid-column: 2; grid-row: 1; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
